import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../../../../../@types/filter";
import { Paginated } from "../../../../../../../../@types/paginated";
import { apisiseci } from "../../../../../../../api";
import { useDefaultSearchParams } from "../../../../../../../../hooks/useSearchParams";
import { AttendanceLocalDepartmentQueue } from "../../../../../../../../@types/attendance-local-department-queue";
import { AttendanceLocalDepartmentQueueServiceTimeComplementException } from "../../../../../../../../@types/attendance-local-department-queue-service-time-complement-exception";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
    fila?: AttendanceLocalDepartmentQueue['id'];
}

export function useAttendanceLocalDepartmentQueueServiceTimeComplementExceptionList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    return useQuery<Paginated<AttendanceLocalDepartmentQueueServiceTimeComplementException>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['attendance-local', 'department', 'queue', 'service-time-complement-exception', 'list', params],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<AttendanceLocalDepartmentQueueServiceTimeComplementException>>(
                "/cms/excecao_horario_agendamento_complementar/",
                { headers: { Authorization: `Bearer ${token}` }, params }
            );
            return response.data;
        },
    });
}
